import { render, staticRenderFns } from "./UserCreationStep2.vue?vue&type=template&id=122004d0"
import script from "./UserCreationStep2.vue?vue&type=script&lang=ts"
export * from "./UserCreationStep2.vue?vue&type=script&lang=ts"
import style0 from "./UserCreationStep2.vue?vue&type=style&index=0&id=122004d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports